import React, { useState } from "react";
import { observer } from "mobx-react";
import { useNavigation } from "@navigation";
import { useGetAccommodationDocUploaderDataQuery } from "@graphql";
import { ErrorCard, Spinner } from "@components";
import { WeekYear } from "@bonliva-crm/common";
import { AccommodationConfirmationStore } from "./AccommodationConfirmationStore";
import { AccommodationConfirmationForm } from "./AccommodationConfirmationForm";

type Props = {
  bookingId: string;
  files: File[];
  week: WeekYear;
};

export const AccommodationConfirmationCreatePage = observer((props: Props) => {
  const [formStore, setFormStore] = useState<AccommodationConfirmationStore>(null);
  const nav = useNavigation();

  const { loading, error } = useGetAccommodationDocUploaderDataQuery({
    variables: {
      bookingId: props.bookingId
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const initialValues = {
        offerId: "",
        accommodationId: "",
        area: formStore?.isConsultantEmployee ? "" : "0",
        files: props.files,
        city: "",
        totalCost: null,
        // The create page only ever produces a legacy CRM-authored row.
        source: "legacy",
        taxationId: null,
        weeks: [
          {
            weekYear: props.week,
            isTaxed: true,
            cost: "0",
            extraCost: "0",
            extraDescription: null,
            startDate: null,
            endDate: null,
            tax: 0,
            nights: "1",
            note: null
          }
        ]
      };

      const s = new AccommodationConfirmationStore(
        null,
        props.bookingId,
        data.bookingById,
        initialValues,
        data.bookingById.BookingGroup.bookings.filter((x) => !x.isOpen).map((x) => x.Week)
      );
      setFormStore(s);
    }
  });

  if (!formStore || loading) {
    return <Spinner fullHeight />;
  }

  if (error) {
    return <ErrorCard title="Cannot load data" message={error.toString()} />;
  }

  nav.lockNavigation("accom_doc_uploader", formStore.form.dirty);

  return <AccommodationConfirmationForm isNew formStore={formStore} />;
});
